import { v4 as uuid } from 'uuid';
import { FC, ComponentProps } from 'react';

export type Source = {
    srcset: string;
    breakpoint: string;
};

type Props = {
    sources?: Source[];
};

const Image: FC<Props & ComponentProps<'img'>> = ({ src, alt, className, sources }) => {
    return (
        <picture>
            {sources &&
                sources.map((source) => (
                    <source key={uuid()} media={`(min-width:${source.breakpoint}})`} srcSet={source.srcset} />
                ))}
            <img src={src} alt={alt} className={className} />
        </picture>
    );
};

export default Image;
